import React from 'react';
import Modal, { ModalTransition } from '@atlaskit/modal-dialog';
import Button from 'kingpin/atoms/Button';
import Typography from 'kingpin/atoms/Typography';

import Row from '../../Common/Row';
import Form from '../../../kingpin/forms/Form';
import FormHeader from '../../../kingpin/forms/FormHeader';
import FormContent from '../../../kingpin/forms/FormContent';
import Alert from '../../../kingpin/Alert';

const DeleteCommitmentPopup = ({
  isOpen,
  close,
  onDeleteConfirmed,
  isSaving,
}: {
  isOpen: boolean;
  close: () => void;
  onDeleteConfirmed: () => void;
  isSaving: boolean;
}) => (
  <ModalTransition>
    {isOpen && (
      <Modal onClose={close} shouldScrollInViewport={false} autoFocus={false}>
        <Form>
          <FormHeader title="Delete Commitment" onClose={close} />
          <FormContent>
            <div style={{ marginBottom: 16 }}>
              <Alert
                type={'Danger'}
                title={'Warning'}
                body={
                  <>
                    <Typography.Body type="Body 14">
                      All history associated with this commitment will be
                      deleted.
                    </Typography.Body>
                    <Typography.Body type="Body 14">
                      This action can not be undone.
                    </Typography.Body>
                  </>
                }
              />
            </div>

            <Alert
              type={'Info'}
              body={
                'Please note that it may take a few minutes before this change is reflected in the data'
              }
            />
          </FormContent>
          <Row spaceBetween centerAlign>
            <Button
              onClick={close}
              label={'Cancel'}
              size="Small"
              type="Ghost"
            />
            <Button
              onClick={onDeleteConfirmed}
              isLoading={isSaving}
              isDisabled={isSaving}
              label="Confirm"
              type="Primary"
              size="Small"
            />
          </Row>
        </Form>
      </Modal>
    )}
  </ModalTransition>
);

export default DeleteCommitmentPopup;
